import Vue from 'vue'
import Router from 'vue-router'

//routes
import defaultRoutes from './default'

// session components
const SignUpOne = () => import('Views/session/SignUpOne')
const LoginOne = () => import('Views/session/LoginOne')
const LockScreen = () => import('Views/session/LockScreen')
const ForgotPassword = () => import('Views/session/ForgotPassword')
const ResetPassword = () => import('Views/session/ResetPassword')

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		defaultRoutes,
		{
			path: '/session/sign-up',
			component: SignUpOne,
			meta: {
				title: 'message.signUp',
                subTitle: null,
				breadcrumb: null
			}
		},
		{
			path: '/session/login',
			component: LoginOne,
			meta: {
				title: 'message.login',
                subTitle: null,
				breadcrumb: null
			}
		},
		{
			path: '/session/lock-screen',
			component: LockScreen,
			meta: {
				title: 'Lock Screen',
                subTitle: null,
                breadcrumb: null
			}
		},
		{
			path: '/session/forgot-password',
			component: ForgotPassword,
			meta: {
				title: 'message.forgotPassword',
                subTitle: null,
				breadcrumb: null
			}
		},
		{
			path: '/session/reset-password',
			component: ResetPassword,
			meta: {
				title: 'message.resetPassword',
                subTitle: null,
				breadcrumb: null
			}
		},
		{
			path: '/*',
			redirect: {name: 'Dashboard'}
		}
	]
})
